import colors from '../../../public/colors'


const styles = theme => {
    const { mode } = theme.palette
    return {
        button: {
            '&.MuiButton-root': {
                border: '1px solid #006AC3',
                borderRadius: '4px',
                boxShadow: 'none',
                boxSizing: 'border-box',
                height: '40px'
            }
        },
        buttonContainer: {
            display: 'flex',
            padding: theme.spacing(3, 0, 3, 0)
        },
        copyWrapper: {
            padding: '50px 24px',
            [theme.breakpoints.down('sm')]: {
                alignItems: 'center',
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
            }
        },
        gridContainerCenter: {
            backgroundColor: colors[mode].secondaryBackground,
            display: 'flex',
            justifyContent: 'center',
            minHeight: '70vh',
        },
        gridContainerFooter: {
            display: 'flex',
            justifyContent: 'center',
        },
        header: {
            alignItems: 'center',
            display: 'flex',
            marginBottom: theme.spacing(4),
            [theme.breakpoints.down('sm')]: {
                alignItems: 'center',
                flexDirection: 'column',
                justifyContent: 'center',
            }
        },
        noAccessRoot: {
            display: 'inline-flex',
            padding: theme.spacing(12, 4, 4, 4),
            [theme.breakpoints.down('sm')]: {
                justifyContent: 'center',
            }
        },
        returnButton: {
            '&.MuiButton-contained': {
                '&:focus': {
                    backgroundColor: '#E5C901',
                    boxShadow: 'none'
                },
                '&:hover': {
                    backgroundColor: '#E5C901',
                    boxShadow: 'none'
                },
                alignItems: 'center',
                backgroundColor: '#FEDF01',
                borderRadius: '2px',
                boxShadow: 'none',
                color: '#003168',
                display: 'flex',
                flexDirection: 'column',
                flexGrow: 0,
                fontFamily: 'Roboto',
                fontSize: '12px',
                fontStyle: 'normal',
                fontWeight: 400,
                height: '32px',
                justifyContent: 'center',
                letterSpacing: '0.46px',
                lineHeight: '16px',
                order: 2,
                padding: '8px 16px',
                textTransform: 'uppercase'
            }
        },
        title: {
            color: colors[mode].errorTitle,
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '24px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '-0.5px',
            lineHeight: 'var(--4, 32px)',
            marginBottom: '28px'
        },
        verbiage: {
            color: colors[mode].errorVerbiage,
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
        },
        verbiageHelpText: {
            color: colors[mode].errorVerbiage,
            fontFamily: 'Roboto',
            fontFeatureSettings: '\'liga\' off, \'clig\' off',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 400,
            letterSpacing: '0.17px',
            lineHeight: '20px',
            paddingBottom: '16px'
        }
    }
}

export default styles